const TenantActionTypes = {
    FETCH_TENANTS_START: "FETCH_TENANTS_START",
    FETCH_TENANTS_SUCCESS: "FETCH_TENANTS_SUCCESS",
    FETCH_TENANTS_FAILURE: "FETCH_TENANTS_FAILURE",
};

export default TenantActionTypes;
